"use strict";

import React, {useState, useEffect} from 'react';
import {useForm} from "react-hook-form";
import SaveCancelButtons from "../../component/SaveCancelButtons";
import Icon from "../../component/Icon";
import passwordValidationSettings from "../utilities/passwordValidationSettings";
import PasswordError from "./PasswordError";
import formInputErrorClassName from "../../formInputErrorClassName";

const AccountPasswordForm = ({passwordSuggestion='',onSubmit=()=>{}, onCancel=()=>{},}) => {
    const [disabled, setDisabled] = useState(false);
    const {register, handleSubmit, watch, reset, getValues, formState: { errors }, } = useForm();
    const watchPassword = watch("password", '');

    useEffect(()=>{
        setDisabled(()=>{
           return !watchPassword;
        });
    }, [watchPassword]);

    useEffect(()=>{
        reset({...getValues(), new_password: passwordSuggestion, new_password_confirmation: passwordSuggestion});
    },[passwordSuggestion, getValues, reset]);

    function handlePasswordFormSubmit(data={}){
        onSubmit(data).then(()=>{
            reset();
        });
    }

    function formInputClassName(name = '') {
        return formInputErrorClassName(name, errors);
    }

    function handleCancelClick(e){
        e.preventDefault();
        reset();
        onCancel();
    }

    return (
        <form id="account__password__form"
              className="account__password__form"
              onSubmit={handleSubmit(handlePasswordFormSubmit)} noValidate >
            <fieldset className="account___form__fieldset">
                <legend>Password</legend>
                <ol className="form__input-list account___form__list is-marginless">
                    <li className="form__input-list-item">
                        <label htmlFor="account-form---password">Current Password:</label>
                        <input type="password"
                               {...register('password', {required: true})}
                               id="account-form--password"
                               defaultValue=""
                               className={formInputClassName('password')} />
                        {!!errors.password &&
                        <small className="form__error">
                            {errors.password.type === 'required' && 'A valid password is required' }
                        </small>
                        }
                    </li>
                    <li className="form__input-list-item">
                        <label htmlFor="account-form--new_password">New Password:</label>
                        <input type="password"
                               {...register('new_password', passwordValidationSettings)}
                               id="account-form---new_password"
                               autoComplete="off"
                               defaultValue=""
                               className={formInputClassName('new_password')}/>
                        <PasswordError error={errors.new_password} />
                    </li>
                    <li className="form__input-list-item is-marginless">
                        <label htmlFor="account-form--new_password_confirmation">Confirm New Password:</label>
                        <input type="password"
                               {...register('new_password_confirmation', {
                                   required: true,
                                   minLength: 8,
                                   maxLength: 50,
                                   validate: {
                                       matchesPreviousPassword: (value) => {
                                           const {new_password} = getValues();
                                           return new_password === value;
                                       },
                                   }
                               })}
                               id="account-form---new_password_confirmation"
                               autoComplete="off"
                               defaultValue=""
                               className={formInputClassName('new_password_confirmation')}/>
                        {!!errors.new_password_confirmation &&
                        <small className="form__error">
                            Your new password doesn't match this confirmation password
                        </small>
                        }
                    </li>
                </ol>
            </fieldset>
            <fieldset>
                <SaveCancelButtons wrapperStyle={{paddingTop: 0,}}
                                   visible={!disabled}
                                   saveButtonType="submit"
                                   saveContent={<Icon name="right" className="icon--collapse-right" />}
                                   saveClassName=" has-icon-right"
                                   onCancelClick={handleCancelClick} />
            </fieldset>
        </form>
    );
};

export default AccountPasswordForm;
